<template>
    <div>
        <design-2021-apprentice-multiselect-component
            id="assignment-edit-answer-list-color"
            :placeholder="'Kies een kleur'"
            label="name"
            :multiple-select="false"
            :options="optionsIn"
            :selected-in="selected"
            v-model="selected"
        >
            <template slot="singleLabel" slot-scope="props">
                <div class="label">
                    <div class="color-option" :style="{background: selector}"></div>
                    <div class="color-name">{{ props.option.name }}</div>
                </div>
            </template>

            <template slot="option" slot-scope="props">
                <div class="label">
                    <div class="color-option" :style="{background: props.option.value}"></div>
                    <div class="color-name">{{ props.option.name }}</div>
                </div>
            </template>
        </design-2021-apprentice-multiselect-component>
    </div>
</template>

<script>
    export default {
        name: "design-2021-assignment-edit-type-assignment-part-color-select-list-component",
        props: {
            optionsIn: Array,
        },
        data() {
            return {
                selected: null,
            }
        },
        computed: {
            selector: function() {
                if(!this.selected || this.selected === 'Kies een kleur') {
                    return 'Kies een kleur';
                }
                else {
                    return this.selected.value;
                }
            }
        }
    }

</script>

<style scoped lang="scss">
    #assignment-edit-answer-list-color{
        .label{
            display: flex;

            .color-option {
                height: 14px;
                width: 30px;
            }

            .color-name {
                width: 60px;
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
</style>
